export default {
  HOME: '/',
  REGISTER: '/register',
  LIVE: '/live',
  SPEAKERS: '/speakers',
  STATIC: '/static',
  EXHIBITION: '/exhibition',
  QUESTIONS: '/questions',
  DEMOZONE: '/demozone',
  DEMOZONE_INFO: '/demozone-info',
  EXHIBITION_OF_SPONSORS: '/exhibition-of-sponsors',
  SPONSOR_PAGE: '/sponsor',
} as const;
